import React from 'react';
import { colors, copy } from '@peachjar/components';
import HappyPeople from './HappyPeople.svg';
import LeftQuote from './LeftQuote.svg';
import { css } from 'react-emotion';

const { platinum, prussian, slate } = colors;

const { quotes } = copy;

const styles = {
  container: css({
    minHeight: '500px',
    marginTop: '40px',
    backgroundColor: platinum,
  }),
  quoteBlock: css({
    maxWidth: '60%',
    fontWeight: 400,
    color: prussian,
  }),
  quoteAuthor: css({
    textAlign: 'center',
    color: slate,
  }),
};

const Footer = () => {
  // const { content, author } = quote;
  // const { name, title, school, district } = author;
  return (
    <footer
      className={`layout-column layout-align-center-center flex-auto pj-font-family-thick pt-5 pb-5 ${
        styles.container
      }`}
    >
      <HappyPeople />

      <div
        className={`pj-margin-top--base layout-column layout-align-center-center pj-font-size-03 ${
          styles.quoteBlock
        }`}
      >
        <div style={{ textAlign: 'center' }}>
          <LeftQuote />
          <span>{quotes.laPak_goodStewards.content}</span>
        </div>
        <div className="pj-margin-top--base pj-font-weight-bold">
          {quotes.laPak_goodStewards.author}
        </div>

        <div
          className={`layout-row layout-align-center-center pj-font-size-01 ${
            styles.quoteAuthor
          }`}
        >
          {/* {title}, {school} <br />
          {district} */}
          {quotes.laPak_goodStewards.authorTitle}
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/Footer.jsx